import { imageFieldsFrag } from '@/service/fragments/imageFieldsFrag'
import type { ResultOf } from 'gql.tada'
import { graphql } from '@/service/graphql'
import { playableEntityFrag } from '@/service/fragments/playableEntityFrag'
import { trackLikesContextFrag } from '@/track/trackLikeService'

// TODO: shortTitle is not allowed for anon
// https://t.corp.amazon.com/P258893146

// language=GraphQL
export const trackFieldsFrag = graphql(
    `
        fragment trackFields on Track @_unmask {
            ...playableEntity
            id
            contributingArtists {
                concatenatedName
            }
            title
            ...trackLikesContext
            parentalSettings {
                hasExplicitLanguage
            }
            album {
                title
                shortTitle @include(if: $isAuthenticated)
            }
            duration
            images {
                ...imageFields
            }
        }
    `,
    [imageFieldsFrag, playableEntityFrag, trackLikesContextFrag]
)

export type TrackFields = ResultOf<typeof trackFieldsFrag>
